import React from 'react';
import { ASSETS } from '../constants/assets';
export function HeroBanner() {
  return <div className="relative w-full h-[450px] overflow-hidden" data-id="element-73">
      <img src={ASSETS.heroMain} alt="Suzhou Hero" className="w-full h-full object-cover" data-id="element-74" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40" data-id="element-75" />

      <div className="absolute top-24 left-6 flex flex-col gap-2" data-id="element-76">
        <img src={ASSETS.logoApp} alt="Logo" className="h-10 w-auto self-start" data-id="element-77" />
        <div className="mt-4" data-id="element-78">
          <h1 className="text-4xl font-bold text-white leading-tight tracking-wider" data-id="element-79">
            运河古城
            <br data-id="element-80" />
            云都宿州
          </h1>
        </div>
      </div>

      <div className="absolute bottom-16 right-6" data-id="element-81">
        <div className="border border-white/40 px-2 py-4 rounded-sm backdrop-blur-sm" data-id="element-82">
          <span className="text-white text-lg font-serif [writing-mode:vertical-rl]" data-id="element-83">
            宿州
          </span>
        </div>
      </div>
    </div>;
}